// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.stream-item__p[data-v-d4a337ac]{\n\tcursor: pointer;\n}\n@media (max-width: 767px) {\n[data-v-d4a337ac] * .modal-dialog-centered {\n\t\talign-items: flex-end;\n}\n.mt-100[data-v-d4a337ac] {\n\t\tmargin-top: 0;\n}\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
